// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSecurity_root__oLWSY"};